import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Homepage from './components/Homepage';
import AboutPage from './components/about';
import ProductPage from './pages/ProductPage/ProductPage.jsx';

import PortfolioCarousel from './pages/Portfolio.js';
import ShopPage from './pages/ShopPage/ShopPage';
import TermsAndConditionsWithStyles from './pages/TermsAndConditions.js';
import PrivacyPolicyWithStyles from './pages/PrivacyPolicy.js';
import ReturnsExchangePage from './pages/ReturnsExchangePage.js';
import Celebrity from './components/Celebrity.js';
import ContactUs from './pages/ContactUs.js';
import ClientsPage from './pages/ClientsPage.js';
import CertificationsPage from './pages/CertificationsPage.js';
import Header from './components/Header.jsx';
import UsefulLinks from './components/UsefulLinks.js';
import PaymentSuccessPage from './pages/PaymentSuccessPage.jsx';
import WhatsAppFloatingButton from './components/WhatsAppFloatingButton';
import ScrollFloatingButton from './components/ScrollFloatingButton';
// import PromotionalFlashCard from './components/PromotionalFlashCard/PromotionalFlashCard';

function App() {
  return (
    <Router>
      <Header/>
      {/* <PromotionalFlashCard /> */}
      <Routes>
        <Route path="/" element={<Homepage />} />
        <Route path="/about" element={<AboutPage />} />
        <Route path="/product/png-stove" element={<ProductPage />} />
        <Route path="/product/:productId" element={<ProductPage />} />
        <Route path="/portfolio" element={<PortfolioCarousel />} />
        <Route path="/products" element={<ShopPage />} />
        <Route path="/products/:category" element={<ShopPage />} />
        <Route path="/shop/:category" element={<ShopPage />} />
        <Route path="/PrivacyPolicy" element={<PrivacyPolicyWithStyles />} />
        <Route path="/returns" element={<ReturnsExchangePage />} />
        <Route path="/gallery" element={<Celebrity />} />
        <Route path="/contact-us" element={<ContactUs />} />
        <Route path="/clients" element={<ClientsPage />} />
        <Route path="/certifications" element={<CertificationsPage />} />
        <Route path="/TermsAndConditions" element={<TermsAndConditionsWithStyles />} />
        <Route path="/useful-links" element={<UsefulLinks />} />
        <Route path="/payment-success" element={<PaymentSuccessPage />} />
        <Route path="*" element={<Homepage />} />
      </Routes>
      <ScrollFloatingButton />
      <WhatsAppFloatingButton />
    </Router>
  );
}

export default App;